import { Chip } from "@ui";
import style from "./OperatorModems.module.scss";
import { KyivstarSvg, LifecellSvg, VodafoneSvg } from "../../svg";
import { IOperatorModemsStat } from "@interfaces/admin/operatorModemsStat";
import { EOperator } from "@interfaces/operator.enum";

export function OperatorModems({
    data
}: {
    data: IOperatorModemsStat
}) {
    return (
        <div className={style.container}>
            <div className={style.header}>
                <div className={style.nameContainer}>
                    <div className={style.name}>
                        {
                            {
                                [EOperator.Kyivstar.toLocaleLowerCase()]: <KyivstarSvg />,
                                [EOperator.Vodafone.toLocaleLowerCase()]: <VodafoneSvg />,
                                [EOperator.lifecell.toLocaleLowerCase()]: <LifecellSvg />,
                            }[data.operator.toLocaleLowerCase()]
                        }
                        {data.operator}
                    </div>
                </div>
                <div className={style.chipContainer}>
                    <Chip
                        text="Реальний час"
                        color={({
                            [EOperator.Kyivstar.toLocaleLowerCase()]: "blue",
                            [EOperator.Vodafone.toLocaleLowerCase()]: "red",
                            [EOperator.lifecell.toLocaleLowerCase()]: "orange",
                        } as const)[data.operator.toLocaleLowerCase()]}
                        size="middle"
                    />
                </div>
            </div>
            <div className={style.body}>
                <div className={style.list}>
                    <div className={style.parameter}>
                        <p>Кількість:</p>
                        <p className={style.value}>{data.all}</p>
                    </div>
                    <div className={style.parameter}>
                        <p>Оренда:</p>
                        <p className={style.value}>{data.rent}</p>
                    </div>
                    <div className={style.parameter}>
                        <p>Вільно:</p>
                        <p className={style.value}>{data.free}</p>
                    </div>
                </div>
                <div className={style.divider}></div>
                <div className={style.list}>
                    {
                        [...data.periods].sort((a, b) => a.days - b.days).map((item, i) => (
                            <div key={i} className={style.parameter}>
                                <p>{getDayString(item.days)}</p>
                                <p className={style.value}>{item.count}</p>
                            </div>
                        ))
                    }
                </div>
            </div>
        </div>
    )
}

function getDayString(n: number): string {
    if (!Number.isInteger(n) || n < 0) {
        return `${n} днів`;
    }
    
    const lastDigit = n % 10;
    const lastTwoDigits = n % 100;
    
    if (lastTwoDigits >= 11 && lastTwoDigits <= 19) {
        return `${n} днів`;
    }
    
    if (lastDigit === 1) {
        return `${n} день`;
    }
    
    if (lastDigit >= 2 && lastDigit <= 4) {
        return `${n} дня`;
    }
    
    return `${n} днів`;
}